import { useMediaQuery } from "@mui/material";
import WebpImage from "@src/component/base/WebpImage";
import { EmptySpace } from "@src/component/SignComponent";
import useUser from "@src/hook/useUser";
import { faqListExpert } from "@src/model/applicationModel";
import { Empty, GroupA } from "@src/ruix";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Autoplay, Pagination, Scrollbar } from "swiper/modules";
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react";
import {
	CIListContainer,
	CListPagination,
	ContentsContainer,
	ExpertCtaContentsContainer,
	ExpertCtaContentsInner,
	ExpertMainCtaButton,
	ExpertProcessCard,
	ExpertProcessCardList,
	ExpertReviewCard,
	ExpertReviewData,
	ExpertTrustCard,
	ExpertWhyOnpointData,
	FAQAnswerDiv2,
	MainContentsContainer,
	ResponsibilityCard,
	ResponsibilityData,
	ReviewContainer,
	SectionSubTitle,
	SectionTitle,
	TrustData,
	WhyOnePointBox,
	WhyOnePointDiv,
} from "../../base/BaseContents";
import { FAQSection } from "../../main/pc/MainContents";

export const ExpertContents = () => {
	const { user } = useUser();
	const router = useRouter();

	const [lastScrollTop, setLastScrollTop] = useState(0);

	const isScrollingUp = () => {
		const currentScrollTop = window.scrollY;
		const scrollingUp = currentScrollTop < lastScrollTop;
		setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
		return scrollingUp;
	};

	useEffect(() => {
		const scrollFunction = () => {
			if (
				scrollY > (document.querySelector("#expert-apply-mid") as any)?.offsetHeight &&
				!isScrollingUp()
			) {
				document.querySelector("#floating-btn")?.classList.remove("hidden");
			} else {
				document.querySelector("#floating-btn")?.classList.add("hidden");
			}
		};
		window.addEventListener("scroll", scrollFunction);
		return () => {
			window?.removeEventListener("scroll", scrollFunction);
		};
	}, [lastScrollTop]);

	const 플로팅버튼 = () => (
		<>
			<div
				onClick={() => {
					router.push("/match/my?type=expert");
				}}
				id="floating-btn"
				className="hidden"
			>
				<div>지금 바로 지원하기</div>
			</div>
		</>
	);

	return (
		<>
			<MainContentsContainer className="column-center-start">
				<MainCtaContents />
				<TrustSection />
				<ReviewSection />
				<WhyOnePoint />
				<OnePointResponsibility />
				<Process />
				<CIList />
				{플로팅버튼()}
				<FAQSection list={faqListExpert[0]} />
			</MainContentsContainer>
		</>
	);
};

const MainCtaContents = () => {
	const { user } = useUser();
	const router = useRouter();
	return (
		<ExpertCtaContentsContainer className="column-center-center">
			<ContentsContainer className="column-center-center">
				<ExpertCtaContentsInner className="column-center-start">
					<h1
						className="cta-title-box"
						style={{
							margin: "0 auto",
						}}
					>
						<div className="row-center-center">
							<span>상위 10% 마케터를 위한</span>
						</div>
						<div className="row-center-center">
							<span>{"프리랜서 플랫폼"}</span>
						</div>
					</h1>
					<ExpertMainCtaButton
						variant="outlined"
						id="expert-apply-mid"
						onClick={() => {
							router.push("/match/my?type=expert");
						}}
					>
						지금 바로 지원하기
					</ExpertMainCtaButton>
				</ExpertCtaContentsInner>
			</ContentsContainer>
		</ExpertCtaContentsContainer>
	);
};

const WhyOnePointSections = () => {
	const a = 1;

	const isPc = useMediaQuery("(min-width: 768px)");

	return (
		<>
			{ExpertWhyOnpointData.map((section, index) => (
				<React.Fragment key={index}>
					<EmptySpace space={40} />
					<WhyOnePointBox className={isPc ? "row-center-between" : "row-center-center"}>
						<WhyOnePointDiv className="column-start-start">
							<div className="label">{section.label}</div>
							<div className="title">{section.title}</div>
							<div className="description">
								{section.description.split("\n").map((line, i) => (
									<React.Fragment key={i}>
										{line}
										<br />
									</React.Fragment>
								))}
							</div>
						</WhyOnePointDiv>
						<WebpImage width={240} src={section.image} alt={section.label} />
					</WhyOnePointBox>
				</React.Fragment>
			))}
		</>
	);
};

const WhyOnePoint = () => {
	const a = 1;
	return (
		<ContentsContainer className="column-center-start">
			<SectionTitle>왜 원포인트 인가요?</SectionTitle>
			{WhyOnePointSections()}
		</ContentsContainer>
	);
};

const OnePointResponsibility = () => {
	const a = 1;

	const isPc = useMediaQuery("(min-width: 1024px)");

	return (
		<ContentsContainer className="column-center-start">
			<SectionTitle>원포인트가 확실히 책임져요</SectionTitle>
			<EmptySpace space={40} />
			<GroupA order={isPc ? "row-center-center" : "column-center-center"} gap={32}>
				{ResponsibilityData.map((data, index) => (
					<ResponsibilityCard key={index} className="column-start-start">
						<WebpImage
							className="responsibility-img"
							src={data.image}
							alt={data.title}
						/>
						<div className="title">{data.title}</div>
						<div className="desc">{data.desc}</div>
					</ResponsibilityCard>
				))}
			</GroupA>
		</ContentsContainer>
	);
};

const ReviewSection = () => {
	const a = 1;
	return (
		<ContentsContainer>
			<ReviewContainer>
				<SwiperComponent
					modules={[Pagination, Scrollbar, Autoplay]}
					slidesPerView={1}
					slidesPerGroup={1}
					centeredSlides={false}
					loop={true}
					spaceBetween={20}
					pagination={{
						clickable: true,
						el: ".c-list-pagination2",
					}}
					autoplay={{
						delay: 3000,
						disableOnInteraction: true,
						pauseOnMouseEnter: true,
					}}
					breakpoints={{
						820: {
							slidesPerView: 3,
							slidesPerGroup: 3,
							spaceBetween: 20,
							centeredSlides: false,
							autoplay: {
								delay: 5000,
								disableOnInteraction: true,
								pauseOnMouseEnter: true,
							},
						},
					}}
				>
					{ExpertReviewData.map((v, i) => (
						<SwiperSlide key={`review-${i}`}>
							<ExpertReviewCard>
								<GroupA order="column-center-start" gap={16}>
									<GroupA order="column-center-start" gap={8}>
										<div className="title">{v.title}</div>
										<div className="desc">{v.description}</div>
									</GroupA>
									<GroupA order="column-start-start" gap={8} fullWidth>
										<div className="name row-center-center">
											<span>{v.position}</span>
											<span className="name-gray">{v.name}</span>
										</div>
									</GroupA>
								</GroupA>
							</ExpertReviewCard>
						</SwiperSlide>
					))}
				</SwiperComponent>
			</ReviewContainer>
			<EmptySpace space={24} />
			<CListPagination className="c-list-pagination2 row-center-center"></CListPagination>
		</ContentsContainer>
	);
};

const Process = () => {
	const isPc = useMediaQuery("(min-width: 1024px)");
	return (
		<ContentsContainer
			className="column-center-start"
			style={{
				background: "var(--bg-white)",
				padding: "64px 0",
			}}
		>
			<GroupA order="column-center-center" gap={0}>
				<SectionTitle>{`등록 프로세스`}</SectionTitle>
				<SectionSubTitle>3단계 프로세스로 하드 및 소프트 스킬을 검증합니다</SectionSubTitle>
			</GroupA>
			<EmptySpace space={40} />
			<GroupA order={isPc ? "row-start-between" : "column-center-center"} gap={16}>
				{ExpertProcessCardList.map((item, index) => (
					<ExpertProcessCard
						key={"ExpertProcessCard" + index}
						imgSrc={item.imgSrc}
						title={item.title}
						subTitle={item.subTitle}
					/>
				))}
			</GroupA>
		</ContentsContainer>
	);
};

const TrustSection = () => {
	const a = 1;
	return (
		<ContentsContainer className="column-start-start">
			<GroupA fullWidth order="column-center-center" gap={0}>
				<FAQAnswerDiv2>왜 프리랜서로 일해야 하나요?</FAQAnswerDiv2>
				<Empty space={20} />
				<SectionTitle>잘하는 일로 수입도 만들고</SectionTitle>
				<SectionTitle>더 성장하고 싶다면</SectionTitle>
			</GroupA>
			<Empty space={20} />
			<GroupA order="row-center-center" gap={8}>
				{TrustData.map((data, index) => (
					<ExpertTrustCard key={index} className="column-center-center">
						<GroupA order="row-center-center" gap={0} fullWidth>
							<div className="num">{data.num}</div>
							<div className="numstr">{data.numstr}</div>
						</GroupA>
						<div className="title">{data.title}</div>
					</ExpertTrustCard>
				))}
			</GroupA>
		</ContentsContainer>
	);
};

const CIList = () => {
	//
	const a = 1;
	return (
		<ContentsContainer className="column-center-start">
			<SectionTitle>성장하는 기업과 함께하세요</SectionTitle>
			<EmptySpace space={40} />
			<CIListContainer className="row-center-between">
				<WebpImage src="/onepoint/images/renewal/ci-section/1-1.png" alt="company1-1" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-2.png" alt="company1-2" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-3.png" alt="company1-3" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-4.png" alt="company1-4" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-5.png" alt="company1-5" />
				<WebpImage src="/onepoint/images/renewal/ci-section/1-6.png" alt="company1-6" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-7.png" alt="company1-7" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-8.png" alt="company1-8" />

				<WebpImage src="/onepoint/images/renewal/ci-section/2-1.png" alt="company2-1" />

				<WebpImage src="/onepoint/images/renewal/ci-section/2-2.png" alt="company2-2" />

				<WebpImage src="/onepoint/images/renewal/ci-section/2-3.png" alt="company2-3" />

				<WebpImage src="/onepoint/images/renewal/ci-section/2-4.png" alt="company2-4" />
			</CIListContainer>
			<EmptySpace space={60} />
		</ContentsContainer>
	);
};
